import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1623e38d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "clients"
};
const _hoisted_2 = {
    key: 1,
    class: "logos-container"
};
const _hoisted_3 = { class: "logo-row" };
const _hoisted_4 = ["onMouseover", "onMouseleave"];
const _hoisted_5 = ["href", "title"];
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = ["href", "title"];
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    key: 2,
    class: "logos_mobile"
};
const _hoisted_10 = { class: "splide__track" };
const _hoisted_11 = { class: "splide__list" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "logos_mobile--content" };
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "client_logos--logo__discover" }, "Discover", -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "splide__arrows" }, null, -1));
import { ref, onMounted, onUnmounted, reactive } from 'vue';
import Splide from '@splidejs/splide';
export default /*#__PURE__*/ _defineComponent({
    __name: 'client_logos',
    props: ['d'],
    setup(__props) {
        const d = __props;
        const currentLogoType = ref([]); // Keep track of the current logo type
        const visibleClients = ref([]);
        const hoveredLogo = ref(null);
        const main = ref(null);
        const isSimpleVersion = ref(d.d.clients.length == 8); // If we have 8 logos, this should be the simple version of the module where we show 4 x 2, without the clients text
        const splider = ref();
        const observer = reactive({
            instance: null
        });
        // Check if the device is mobile/tablet or desktop based on screen width
        const isMobile = ref(window.innerWidth <= 576); // Adjust the width threshold as needed
        const isTablet = ref(window.innerWidth > 576 && window.innerWidth <= 992);
        const isDesktop = ref(window.innerWidth > 992);
        const updateWindowSize = () => {
            const width = window.innerWidth;
            isMobile.value = width <= 576;
            isTablet.value = width > 576 && width <= 992;
            isDesktop.value = width > 992;
        };
        onMounted(() => {
            visibleClients.value = chunkArray(d.d.clients); // Split clients into 9 arrays with an offset of 9 if we are using the complex version
            // Initialise currentLogoType with 'initial' for each pair
            currentLogoType.value = Array(visibleClients.value.length).fill('initial');
            // Initialize Intersection Observer
            observer.instance = new IntersectionObserver(handleIntersection, {
                root: null,
                rootMargin: "-40% 0% -40% 0%",
                threshold: 0
            });
            // Observe target element
            observer.instance.observe(main.value);
        });
        onUnmounted(() => {
            // Cleanup Observer
            if (observer.instance) {
                observer.instance.disconnect();
            }
        });
        function handleIntersection(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting && !isSimpleVersion.value) {
                    startLogoTransition();
                    observer.unobserve(entry.target);
                }
            });
        }
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            updateWindowSize();
        });
        document.addEventListener('DOMContentLoaded', function () {
            new Splide(splider.value, {
                focus: 'center',
                type: 'loop',
                pagination: false,
                perPage: 3,
                perMove: 1,
                width: '100%',
                autoWidth: true,
                drag: true,
                autoplay: true,
                arrows: false,
                interval: 3000,
                flickMaxPages: 1,
            }).mount();
        });
        function splideClicked(alias) {
            window.location.href = alias;
        }
        // Function to start the logo transition sequence
        function startLogoTransition() {
            setInterval(() => {
                // Generate a random logo index
                const randomIndex = Math.floor(Math.random() * visibleClients.value.length);
                // Toggle the logo type for the randomly selected pair
                currentLogoType.value = currentLogoType.value.map((type, index) => {
                    if (index === randomIndex && hoveredLogo.value !== randomIndex) {
                        return type === 'initial' ? 'alternate' : 'initial';
                    }
                    else {
                        return type;
                    }
                });
            }, 1000); // Change a logo every 2 seconds
        }
        // Function to split array into chunks
        function chunkArray(array) {
            const pairs = [];
            if (isSimpleVersion.value) {
                for (let i = 0; i < array.length; i++) {
                    pairs.push([array[i], array[i]]);
                }
            }
            else {
                for (let i = 0; i < array.length - 9; i++) {
                    pairs.push([array[i], array[i + 9]]);
                }
            }
            return pairs;
        }
        function stopAnimation(index) {
            hoveredLogo.value = index;
        }
        function startAnimation(index) {
            hoveredLogo.value = null;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: "client_logos",
                    ref_key: "main",
                    ref: main
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass({ 'container': !isMobile.value, 'inner': isMobile.value })
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["two-column", { 'two-column__top': isTablet.value || isMobile.value, 'container_full_width': isMobile.value }])
                        }, [
                            ((isDesktop.value && !isSimpleVersion.value) || !isSimpleVersion.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["rotate-text", { 'rotate-text__transform': isDesktop.value }])
                                    }, "Clients", 2)
                                ]))
                                : _createCommentVNode("", true),
                            (isDesktop.value || isTablet.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleClients.value, (client, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "client_logos--logo",
                                                onMouseover: ($event) => (stopAnimation(index)),
                                                onMouseleave: ($event) => (startAnimation(index))
                                            }, [
                                                (currentLogoType.value[index] === 'initial')
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: client[0].link,
                                                        class: "client_logo--link no-style",
                                                        title: client[0].title
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: client[0].logo,
                                                            alt: client[0].title,
                                                            width: "200",
                                                            height: "200",
                                                            loading: "lazy"
                                                        }, null, 8, _hoisted_6)
                                                    ], 8, _hoisted_5))
                                                    : _createCommentVNode("", true),
                                                (currentLogoType.value[index] === 'alternate')
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 1,
                                                        href: client[1].link,
                                                        class: "client_logo--link no-style",
                                                        title: client[1].title
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: client[1].logo,
                                                            alt: client[1].title,
                                                            width: "200",
                                                            height: "200",
                                                            loading: "lazy"
                                                        }, null, 8, _hoisted_8)
                                                    ], 8, _hoisted_7))
                                                    : _createCommentVNode("", true)
                                            ], 40, _hoisted_4));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isMobile.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", {
                                        ref_key: "splider",
                                        ref: splider,
                                        class: "splide"
                                    }, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("ul", _hoisted_11, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.d.clients, (client, index) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        class: "splide__slide",
                                                        onClick: ($event) => (splideClicked(client.link))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_13, [
                                                            _createElementVNode("img", {
                                                                src: client.logo,
                                                                alt: client.title,
                                                                width: "200",
                                                                height: "200",
                                                                loading: "lazy"
                                                            }, null, 8, _hoisted_14),
                                                            _hoisted_15
                                                        ])
                                                    ], 8, _hoisted_12));
                                                }), 256))
                                            ])
                                        ]),
                                        _hoisted_16
                                    ], 512)
                                ]))
                                : _createCommentVNode("", true)
                        ], 2)
                    ], 2)
                ], 512)
            ]));
        };
    }
});
